import {
  UseMutationResult,
  useQueryClient,
  useMutation,
} from '@tanstack/react-query';
import { axiosInstance } from 'hooks/auth/AxiosInstance';

interface UpdateOffence {
  id: number;
  name: string;
  isSlabRateApplicable: '' | 'Y' | 'N';
  offenceLabel: string;
  sectionAct: string;
  amount: number;
}

const updateOffence = async (data: UpdateOffence) => {
  const response = await axiosInstance.put(`/offence/${data.id}`, data);
  return response.data;
};

const useUpdateOffence = (): UseMutationResult<
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  any,
  Error,
  UpdateOffence
> => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateOffence,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['offence'] });
      queryClient.invalidateQueries({ queryKey: ['offences'] });
    },
    onError: (error: Error) => {
      console.error('Error updating offence:', error.message);
    },
  });
};

export default useUpdateOffence;
